import { NeoModel } from '@singularsystems/neo-core';
import { Views } from '@singularsystems/neo-react';
import { AppService, Types } from '../../../App/Services/AppService';
import InstrumentSearchLookup from '../../../DataInterception/InstrumentMapping/Models/InstrumentSearchLookup';

@NeoModel
export default class ManageInstrumentComponentVM extends Views.ViewModelBase {

    public managedInstrument = new InstrumentSearchLookup();

    constructor(
        taskRunner = AppService.get(Types.Neo.TaskRunner),
        public instrumentTypeApiClient = AppService.get(Types.ApiClients.InstrumentTypeApiClient)) {
        super(taskRunner);
    }

    public async initialise() {
    }
}